import { render, staticRenderFns } from "./SideMenuNav.vue?vue&type=template&id=37d36d22&scoped=true&lang=pug&"
import script from "./SideMenuNav.vue?vue&type=script&lang=js&"
export * from "./SideMenuNav.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuNav.vue?vue&type=style&index=0&id=37d36d22&lang=scss&scoped=true&"
import style1 from "./SideMenuNav.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d36d22",
  null
  
)

export default component.exports